export default "__VITE_ASSET__c99bb77c__"